<template>
    <div class="audioBox" :class="isShowAudioBox ? 'act' : ''" @mouseover="audioBoxMouseover" @mouseout="audioBoxMouseout" ref="audioBox">
        <div ref="audioWrapper">
            <div class="lock" @click="lock">
                <div :class="isLock ? 'off' : ''"></div>
            </div>
            <img :src="bookInfo.cover" alt="" class="bookCover" @click="goBook">
            <div class="play_operate_btn">
                <div class="prev" @click="prevAudio"></div>
                <div class="play paused" ref="playBtn" @click="playOrPause"></div>
                <div class="next" @click="nextAudio"></div>
            </div>
            <div class="play_body">
                <p class="name">{{ actChapter.name }}</p>
                <div>
                    <div class="progress" ref="audioProgress" @click.stop.prevent="audioProgress($event)">
                        <div class="bar" ref="audioBar"></div>
                        <div class="pie" ref="audioPie" @mousedown.stop="audioPieMousedown($event)"></div>
                    </div>
                    <div class="play_time">
                        <span class="currentTime">{{ commin.fn.setAudioTime(currentTime) }}/</span><span class="duration">{{ commin.fn.setAudioTime( !actChapter.duration ? 0 : actChapter.duration) }}</span>
                    </div>
                </div>
            </div>
            <div class="controls">
                <div :class="isCollected ? 'act' : ''" @click="collectState"></div>
                <div @click.stop="showChapters"></div>
            </div>
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                <div class="chapters" v-if="isShowChapters">
                    <h2>播放列表</h2>
                    <div ref="boxH" @scroll.passive="onScroll">
                        <ul ref="scrollH">
                            <li v-for="(item, index) in chapters" :key="index" :class="index == actChapterIdx ? 'act' : ''" @click="playAudio(item, index)">
                                <div>
                                    <div>{{ item.sort }}</div>
                                    <div></div>
                                </div>
                                <div></div>
                                <p>{{ item.name }}</p>
                                <span>{{ commin.fn.setAudioTime(item.duration) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
// import { setTimeout } from 'timers';

export default {
    data() {
        return {
            audio: null,
            isPlaying: false,
            currentTime: 0,
            audioSlideWidth: 0,
            isAudioMove: false,
            pageNum: -1,
            prevNum: -1,
            nextNum: -1,
            totalPage: -1,
            direction: "no",
            prevAndNextBtn: false,
            isMoreChapters: true,
            isShowChapters: false,
            isLock: true,
            isShowAudioBox: true,
            isOpenVolume: false,
            volume: 1,
            isCollected: false,
            historyAddCurrenttime: 0,
            firstHistoryAdd: false,
        }
    },
    props: {
        dialogHide: Boolean,
    },
    computed: {
        online(){
            return this.$store.state.online;
        },
        bookInfo(){
            return this.$store.state.bookInfo;
        },
        collectCode(){
            return this.$store.state.collectCode;
        },
        historyCode(){
            return this.$store.state.historyCode;
        },
        chapters(){
            return this.$store.state.chapters;
        },
        actChapterIdx(){
            return this.$store.state.actChapterIdx;
        },
        actChapter(){
            return this.$store.state.actChapter;
        },
        actChapterCurrentTime(){
            return this.$store.state.actChapterCurrentTime;
        },
        stateTotalPage(){
            return this.$store.state.totalPage;
        },
    },
    mounted() {
        let that = this;
        that.createAudio();
        that.totalPage = that.stateTotalPage;
    },
    methods: {
        createAudio() {
            let that = this;
            that.audio = document.createElement('audio');
            that.audio.oncanplay = that.canplay;
            that.audio.ontimeupdate = that.timeupdate;
            that.audio.onended = that.ended;
            that.audio.onpause = that.pause;
            that.audio.onplay = that.play;
            that.audio.onstalled = that.stalled;
        },
        canplay() {
            let that = this;
            that.audio.play();
            
            // that.audio.playbackRate = 10.0;
        },
        timeupdate() {
            let that = this;
            that.currentTime = that.audio.currentTime;
            that.barMove();
            
            // console.log(that.audio.currentTime)
            if( that.bookInfo.id ) {
                if( that.audio.currentTime < 1 && that.firstHistoryAdd ) {
                    that.historyAddCurrenttime = that.audio.currentTime;
                    that.firstHistoryAdd = false;
                    that.historyAdd();
                }else if( that.audio.currentTime - that.historyAddCurrenttime >= 10 ) {
                    that.historyAddCurrenttime = that.audio.currentTime;
                    that.historyAdd();
                }
            }
            // that.$store.commit("setCurrentTime", that.audio.currentTime);
        },
        ended() {
            let that = this;
            that.nextAudio();
        },
        play() {
            let that = this;
            // that.$refs.playBtn.classList.replace("paused", "playing");
            that.$refs.playBtn.classList.add("playing");
            that.$refs.playBtn.classList.remove("paused");
        },
        pause() {
            let that = this;
            // that.$refs.playBtn.classList.replace("playing", "paused");
            that.$refs.playBtn.classList.add("paused");
            that.$refs.playBtn.classList.remove("playing");
        },
        stalled() {
            let that = this;
            that.audio.currentTime = that.currentTime;
            that.audio.load();
        },
        playOrPause() {
            let that = this;
            if( !that.bookInfo.id ) {
                return false;
            }
            if( that.isPlaying ) {
                that.isPlaying = false;
                // that.$refs.playBtn.classList.replace("playing", "paused");
                that.audio.pause();
            }else{
                that.isPlaying = true;
                // that.$refs.playBtn.classList.replace("paused", "playing");
                that.audio.play();
            }
        },
        prevAudio() {
            let that = this;
            if( !that.bookInfo.id ) {
                return false;
            }

            let chaptersActIdx = that.actChapterIdx-1;

            that.prevNum = that.actChapter.sort % 10 != 0 ? parseInt(that.actChapter.sort / 10) + 1 : parseInt(that.actChapter.sort / 10);
            
            if( chaptersActIdx < 0 ) {
                that.prevNum --;
                
                if( that.prevNum < 1 ){
                    that.prevNum = 1;
                    return false;
                }else{
                    that.direction = 'prev';
                    that.$store.commit("setActChapterIdx", 9);
                    that.prevAndNextBtn = true;
                    that.getChapters();
                }
            }else{
                that.$store.commit("setActChapterIdx", chaptersActIdx);
                that.$store.commit("setActChapter", that.chapters[chaptersActIdx]);
                that.$store.commit("setActChapterCurrentTime", 0);
            }
        },
        nextAudio() {
            let that = this;
            if( !that.bookInfo.id ) {
                return false;
            }

            let chaptersActIdx = that.actChapterIdx+1;

            that.nextNum = that.actChapter.sort % 10 != 0 ? parseInt(that.actChapter.sort / 10) + 1 : parseInt(that.actChapter.sort / 10);
            
            if( chaptersActIdx > that.chapters.length - 1 ) {
                that.nextNum ++;
                if( that.nextNum > that.totalPage ){
                    that.nextNum = that.totalPage;
                    return false;
                }else{
                    that.direction = 'next';
                    that.$store.commit("setActChapterIdx", chaptersActIdx);
                    that.prevAndNextBtn = true;
                    that.getChapters();
                }
            }else{
                that.$store.commit("setActChapterIdx", chaptersActIdx);
                that.$store.commit("setActChapter", that.chapters[chaptersActIdx]);
                that.$store.commit("setActChapterCurrentTime", 0);
            }
        },
        getChapters() {
            let that = this;

            let data = {
                book: that.bookInfo.id,
                history: false,
                size: 10
            }
            
            if( that.direction == 'next' ) {
                data.page = that.nextNum;
            }else if( that.direction == 'prev' ) {
                data.page = that.prevNum;
            }else{
                data.page = that.pageNum;
            }

            that.allApi.chapterList(data).then((resource) => {
                if(  resource.data.code == 200 ) {

                    if( that.direction == 'next' ) {
                        that.$store.commit("setChapters", that.chapters.concat(resource.data.data.page.list));
                    }else if( that.direction == 'prev' ) {
                        that.$store.commit("setChapters", resource.data.data.page.list.concat(that.chapters));
                    }else {
                        that.$store.commit("setChapters", resource.data.data.page.list);
                        that.totalPage = resource.data.data.page.pages;
                        that.$store.commit("setTotalPage", that.totalPage);
                    }
                    if( that.prevAndNextBtn ) {
                        that.$store.commit("setActChapter", that.chapters[that.actChapterIdx]);
                        that.$store.commit("setActChapterCurrentTime", 0);
                    }
                    
                    that.$nextTick(()=>{
                        that.isMoreChapters = true;
                    })
                }
            })
        },
        onScroll() {
            let that = this;
            let boxH = that.$refs.boxH.offsetHeight,
                boxTop = that.$refs.boxH.scrollTop,
                scrollH = that.$refs.scrollH.offsetHeight;
            if( scrollH - boxH - boxTop < 10 && that.isMoreChapters ) {
                that.nextNum ++;
                if( that.nextNum > that.totalPage ) {
                    that.nextNum = that.totalPage
                    return false;
                }else{
                    that.direction = 'next';
                    that.isMoreChapters = false;
                    that.prevAndNextBtn = false;
                    that.getChapters();
                }

            }else if( boxTop <= 0 && that.isMoreChapters ) {
                that.prevNum --;
                if( that.prevNum <= 0 ) {
                    that.prevNum = 1;
                    return false;
                }else{
                    that.direction = 'prev';
                    that.isMoreChapters = false;
                    that.prevAndNextBtn = false;
                    that.$store.commit("setActChapterIdx", that.actChapterIdx + 10);
                    that.getChapters();
                }

            }
        },
        barMove() {
            //进度
            let that = this,
                width = 0;

            if ( that.audio.currentTime == 0 ) {

                width = 0;

            } else {

                width = (that.audio.currentTime / that.audio.duration) * that.$refs.audioProgress.offsetWidth;

            }

            that.$refs.audioPie.style.left = ( -that.$refs.audioPie.offsetWidth / 2 ) + width + "px";

            that.$refs.audioBar.style.width = width + "px";
            
        },
        audioPieMousedown(e) {
            var that = this;
            if( !that.bookInfo.id ) {
                return false;
            }
            that.audio.pause();
            // that.$refs.audioPie.onmousemove = that.audioPieMousemove;
            document.onmousemove = that.audioPieMousemove;
            document.onmouseup = that.audioPieMouseup;
        },
        audioPieMousemove(e) {
            let that = this,
                width = 0;
            if( ( e.clientX - that.$refs.audioProgress.offsetLeft - that.$refs.audioWrapper.offsetLeft ) >= that.$refs.audioProgress.offsetWidth ) {

                width = that.$refs.audioProgress.offsetWidth;

            }else if( ( e.clientX - that.$refs.audioProgress.offsetLeft - that.$refs.audioWrapper.offsetLeft ) <= 0 ){

                width = 0;

            }else{

                width = e.clientX - that.$refs.audioProgress.offsetLeft - that.$refs.audioWrapper.offsetLeft;

            }

            that.audioSlideWidth = parseInt(width) / that.$refs.audioProgress.offsetWidth * that.audio.duration;

            that.$refs.audioPie.style.left = ( -that.$refs.audioPie.offsetWidth / 2 ) + width + "px";

            that.$refs.audioBar.style.width = width + "px";

            that.isAudioMove = true;

        },
        audioPieMouseup(e) {
            var that = this;
            that.audio.currentTime = that.audioSlideWidth;
            setTimeout(() => {
                that.isAudioMove = false;
            }, 200)
            document.onmousemove = null;
            document.onmouseup = null;
        },
        audioProgress(e) {
            // 点击进度条
            var that = this;
            if( !that.bookInfo.id ) {
                return false;
            }
            if( that.isAudioMove ) {
                return false;
            }
            that.$refs.audioBar.style.width = e.offsetX + "px";

            that.$refs.audioPie.style.left = ( -that.$refs.audioPie.offsetWidth / 2 ) + e.offsetX + "px";

            that.audio.currentTime = parseInt(e.offsetX) / that.$refs.audioProgress.offsetWidth * that.audio.duration;
        },
        showChapters() {
            let that = this;
            if( !that.bookInfo.id ) {
                return false;
            }
            that.isShowChapters = true;
            that.$emit("dialogShow");
        },
        playAudio(item, idx) {
            let that = this;
            that.isShowChapters = false;
            // that.$store.commit("setBookInfo", that.bookInfo);
            // that.$store.commit("setChapters", that.chapters);
            that.$store.commit("setActChapter", item);
            that.$store.commit("setActChapterIdx", idx);
            that.$store.commit("setActChapterCurrentTime", 0);
            
        },
        lock() {
            // 锁
            let that = this;
            if( that.isLock ) {
                that.isLock = false;
                that.isShowAudioBox = false;
            }else{
                that.isLock = true;
                that.isShowAudioBox = true;
            }
        },
        audioBoxMouseover() {
            let that = this;
            if( that.isLock ) {
                return false;
            }else{
                that.isShowAudioBox = true;
            }
        },
        audioBoxMouseout() {
            let that = this;
            if( that.isLock ) {
                return false;
            }else{
                that.isShowAudioBox = false;
            }
        },
        collectState() {
            // 添加/删除收藏
            let that = this;
            if( !that.online ) {
                console.log("没有登录！")
                return false;
            }
            if( !that.bookInfo.id ) {
                return false;
            }
            let data = {
                book: that.bookInfo.id
            }
            if( that.collectCode ) {
                data.id = that.collectCode;
                that.allApi.deleteCollect(data).then((resource) => {
                    if( resource.data.code == 200 ) {
                        that.$store.commit("setCollectCode", resource.data.data);
                    }
                })
            }else {
                
                that.allApi.addCollect(data).then((resource) => {
                    if( resource.data.code == 200 ) {
                        that.$store.commit("setCollectCode", resource.data.data);
                    }
                })
            }
        },
        historyAdd() {
            // 添加历史
            let that = this;
            if( !that.online ) {
                console.log("没有登录！")
                return false;
            }
            let data = {
                book: that.bookInfo.id,
                data: new FormData()
            }
            data.data.append("sort", that.actChapter.sort);
            data.data.append("duration", that.audio.currentTime);
            that.allApi.addHistory(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    // if( !that.historyCode ) {
                    //     that.$store.commit("setHistoryCode", resource.data.data);
                    // }
                }
            })
        },
        addPlayNum() {
            let that = this;
            if( !that.bookInfo.id ) {
                return false;
            }
            let data = {
                book: that.bookInfo.id
            }
            that.allApi.bookPlay(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    
                }
            })
        },
        goBook() {
            let that = this;
            if( !that.bookInfo.book ) {
                return false;
            }
            that.$router.push({
                path: '/book',
                query: {
                    id: that.bookInfo.book
                }
            })
        },
    },
    watch: {
        actChapter(newV, oldV) {
            let that = this;
            that.audio.src = newV.audio;
            that.audio.currentTime = that.actChapterCurrentTime;
            that.isPlaying = true;
            that.firstHistoryAdd = true;
            that.addPlayNum();
            // console.log(that.actChapter.rank % 10 != 0 ? parseInt(that.actChapter.rank / 10) + 1 : parseInt(that.actChapter.rank / 10))
            
        },
        stateTotalPage(newV) {
            let that = this;
            that.totalPage = newV;
        },
        bookInfo() {
            let that = this;
            that.pageNum = that.prevNum = that.nextNum = that.actChapter.sort % 10 != 0 ? parseInt(that.actChapter.sort / 10) + 1 : parseInt(that.actChapter.sort / 10);
        },
        collectCode(newV) {
            let that = this;
            if( that.bookInfo.id ) {
                if( !newV ) {
                    that.isCollected = false;
                }else{
                    that.isCollected = true;
                }
            }
        },
        dialogHide(newV) {
            // console.log(newV)
            let that = this;
            if( newV ) {
                that.isOpenVolume = false;
                that.isShowChapters = false;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    @keyframes audioBoxOpen {
        from {
            bottom: -60px;
        }
        to {
            bottom: 0;
        }
    }
    @keyframes audioBoxOff {
        from {
            bottom: 0;
        }
        to {
            bottom: -60px;
        }
    }
    .audioBox{
        height: 84px;
        position: fixed;
        left: 0;
        bottom: -60px;
        width: 100%;
        padding-top: 24px;
        z-index: 9999;
        // @include audio_bg_color(linear-gradient(0deg,rgba(0,0,0,1) 0%,rgba(96,96,96,1) 100%));
        background-image: url('../assets/imgs/audio/bg_bottom.png');
        background-position: bottom center;
        background-repeat: no-repeat;
        background-size: 100% 60px;
        transition: all .5s;
        &.act{
            bottom: 0;
        }
        >div{
            width: 1200px;
            margin: 0 auto;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            >.lock{
                width: 85px;
                height: 24px;
                position: absolute;
                top: -24px;
                right: 0;
                cursor: pointer;
                background-image: url('../assets/imgs/audio/bg_top.png');
                background-position: center;
                background-repeat: no-repeat;
                >div{
                    width: 85px;
                    height: 24px;
                    background-image: url('../assets/imgs/audio/open.png');
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 12px 15px;
                    &.off{
                        background-image: url('../assets/imgs/audio/off.png');
                    }
                }
            }
            >.bookCover{
                width: 46px;
                height: 46px;
                // background: #000;
                border-radius: 5px;
                display: block;
                margin-right: 30px;
                cursor: pointer;
            }
            >.play_operate_btn{
                display: flex;
                align-items: center;
                >div{
                    margin-right: 30px;
                    width: 15px;
                    height: 16px;
                    cursor: pointer;
                    background-repeat: no-repeat;
                    background-position: center;
                    &:first-child{
                        background-image: url('../assets/imgs/audio/prev_btn.png');
                    }
                    &:last-child{
                        background-image: url('../assets/imgs/audio/next_btn.png');
                    }
                }
                >div:nth-child(2){
                    width: 32px;
                    height: 32px;
                    // background-image: url('../assets/imgs/audio/stop_btn.png');
                    &.playing{
                        background-image: url('../assets/imgs/audio/play_btn.png');
                    }
                    &.paused{
                        background-image: url('../assets/imgs/audio/stop_btn.png');
                    }
                }
            }
            >.play_body{
                width: 600px;
                >p{
                    line-height: 20px;
                    font-size: 16px;
                    margin-bottom: 5px;
                    color: #FFFFFF;
                }
                >div{
                    display: flex;
                    >.progress{
                        width: 386px;
                        height: 4px;
                        margin-left: 7px;
                        margin-right: 26px;
                        background: #313131;
                        position: relative;
                        top: 8px;
                        cursor: pointer;
                        >.pie{
                            position: absolute;
                            left: -7px;
                            top: -5px;
                            height: 14px;
                            width: 14px;
                            border-radius: 14px;
                            cursor: pointer;
                            background: #FCFDFE;
                        }
                        >.bar{
                            position: absolute;
                            left: 0;
                            top: 50%;
                            margin-top: -2px;
                            height: 4px;
                            width: 0;
                            background: #1AA7E0;
                            border-radius: 2px;
                        }
                    }
                    >.play_time{
                        width: 0%;
                        flex: 1;
                        font-size: 16px;
                        line-height: 20px;
                        >.currentTime{
                            color: #FFFFFF;
                        }
                        >.duration{
                            color: #B7B7B7;
                        }
                    }
                }
            }
            >.controls{
                display: flex;
                align-items: center;
                >div{
                    margin-right: 30px;
                    cursor: pointer;
                    width: 30px;
                    height: 30px;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:first-child{
                        background-image: url('../assets/imgs/audio/collect_btn.png');
                        &.act{
                            background-image: url('../assets/imgs/audio/collected_btn.png');
                        }
                    }
                    &:nth-child(2){
                        background-image: url('../assets/imgs/audio/sound_btn.png');
                        position: relative;
                        >div{
                            position: absolute;
                            left: 50%;
                            top: -189px;
                            background: #000;
                            height: 174px;
                            width: 60px;
                            margin-left: -30px;
                            border-top-left-radius: 4px;
                            border-top-right-radius: 4px;
                            background: #535353;
                            display: none;
                            >.progress{
                                width: 6px;
                                height: 134px;
                                margin: 20px auto;
                                border-radius: 3px;
                                position: relative;
                                background: #313131;
                                >.pie{
                                    position: absolute;
                                    left: -3px;
                                    top: -6px;
                                    height: 12px;
                                    width: 12px;
                                    border-radius: 12px;
                                    cursor: pointer;
                                    background: #FCFDFE;
                                }
                                >.bar{
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    height: 100%;
                                    width: 100%;
                                    background: #1AA7E0;
                                    border-radius: 3px;
                                }
                            }
                            &.act{
                                display: block;
                            }
                        }
                    }
                    &:last-child{
                        margin-right: 0;
                        background-image: url('../assets/imgs/audio/chapters_btn.png');
                    }
                }
            }
            >.chapters{
                position: absolute;
                left: 0;
                top: -630px;
                background: rgba($color: #000000, $alpha: .8);
                padding: 40px 30px;
                width: 100%;
                height: 630px;
                border-top-left-radius: 14px;
                border-top-right-radius: 14px;
                display: flex;
                flex-direction: column;
                >h2{
                    border-bottom: 1px solid #FCFDFE;
                    font-size: 26px;
                    line-height: 26px;
                    padding-bottom: 20px;
                    color: #FFFFFF;
                    font-weight: 500;
                    margin-bottom: 35px;
                }
                >div{
                    height: 0%;
                    flex: 1;
                    overflow-y: scroll;
                    &::-webkit-scrollbar {/*滚动条整体样式*/
                        width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
                    }
                    &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                        border-radius: 10px;
                        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                        background: rgba($color: #000000, $alpha: .5);
                    }
                    &::-webkit-scrollbar-track {/*滚动条里面轨道*/
                        display: none;
                    }
                    >ul{
                        >li{
                            height: 54px;
                            padding: 0 60px;
                            display: flex;
                            align-items: center;
                            color: #fff;
                            font-size: 22px;
                            // background: rgba($color: #000000, $alpha: .8);
                            >div:first-of-type{
                                width: 80px;
                                margin-right: 20px;
                                height: 40px;
                                line-height: 40px;
                                >div:first-child{
                                    display: block;
                                    text-align: center;
                                }
                                >div:last-child{
                                    height: 40px;
                                    background-image: url('../assets/imgs/audio/chapter_hover_btn.png');
                                    background-position: center;
                                    background-repeat: no-repeat;
                                    display: none;
                                }
                            }
                            >div:last-of-type{
                                width: 80px;
                                height: 40px;
                                margin-right: 20px;
                                display: none;
                                background-image: url('../assets/imgs/audio/playing.gif');
                                background-position: center;
                                background-repeat: no-repeat;
                            }
                            >p{
                                width: 0%;
                                flex: 1;
                            }
                            >span{
                                display: block;
                                margin-left: 20px;
                            }
                            &:hover{
                                background: rgba($color: #FCFDFE, $alpha: .09);
                                >div{
                                    >div:first-child{
                                        display: none;
                                    }
                                    >div:last-child{
                                        display: block;
                                    }
                                }
                            }
                            &.act{
                                >div:first-of-type{
                                    display: none;
                                }
                                >div:last-of-type{
                                    display: block;
                                }
                                >p{
                                    @include dominant_color_act(#1AA7E0);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
